__webpack_require__.p = "/collaboration/";